module.exports = __webpack_public_path__ + "files/07ad0b86989bb4dc4c6c32cdefdb3eb3.svg";